import { createGlobalStyle } from 'styled-components';

// Define theme colors based on the salmon color of the gravel
export const theme = {
  primary: '#FA8072', // Salmon color
  primaryLight: '#FFB6C1', // Light salmon
  primaryDark: '#E9967A', // Dark salmon
  secondary: '#F5F5F5', // Off-white
  text: '#333333', // Dark grey for text
  textLight: '#777777', // Light grey for secondary text
  white: '#FFFFFF',
  black: '#000000',
  borderLight: '#eeeeee',
  borderMedium: '#dddddd',
  disabled: '#cccccc',
  success: '#d4edda',
  successText: '#155724',
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    largeDesktop: '1200px',
  },
};

// Global styles applied to the entire application
const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body {
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    line-height: 1.6;
    color: ${theme.text};
    background-color: ${theme.white};
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 1rem;
    letter-spacing: 0.02em;
  }

  h1 {
    font-size: 2.5rem;
    letter-spacing: 0.03em;
    
    @media (max-width: ${theme.breakpoints.tablet}) {
      font-size: 2rem;
    }
  }

  h2 {
    font-size: 2rem;
    letter-spacing: 0.025em;
    
    @media (max-width: ${theme.breakpoints.tablet}) {
      font-size: 1.75rem;
    }
  }

  p {
    margin-bottom: 1rem;
  }

  a {
    color: ${theme.primaryDark};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${theme.primary};
    }

    &:focus-visible {
      outline: 2px solid ${theme.primary};
      outline-offset: 2px;
      border-radius: 2px;
    }
  }

  button {
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;

    &:focus-visible {
      outline: 2px solid ${theme.primary};
      outline-offset: 2px;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  section {
    padding: 3rem 1rem;
    
    @media (min-width: ${theme.breakpoints.tablet}) {
      padding: 5rem 2rem;
    }
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }
`;

export default GlobalStyles; 